import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import { message, Spin, Table } from 'antd';
import Button from '../../common/Button/Button';
import { useGetMaleModelsData } from '../../hooks/useModel';
import downloadIcon from '../../Images/Dashboard/downloadIcon.svg';
import calendarIcon from '../../Images/Dashboard/calendar.svg';
import { useGetUserTasksStats } from '../../hooks/useUserTasksStats';
import { useGetListAll } from '../../hooks/useListAll';
import axios from 'axios';
// import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { LoadingOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Pagination } from 'antd';
import { useGetTask } from '../../hooks/useTask';
import { useMutation } from 'react-query';
import useCreditContext from '../../hooks/useCreditContext';

const Dashboard = () => {
  const middleRowRef = useRef(null);

  const [allUserStats, setAllUserStats] = useState([]);
  const [listData, setListData] = useState([]);
  const [listPageNum, setListPageNum] = useState(1);
  const [listPageSize] = useState(0);
  const [listTotalCount, setlistTotalCount] = useState(0);
  const [manualData, setManualData] = useState([]);
  const [manualPageNum, setManualPageNum] = useState(1);
  const [manualPageSize] = useState(0);
  const [manualTotalCount, setManualTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1134);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const [taskData, setTaskData] = useState([]);


  const navigate = useNavigate();

  let userInfo = JSON.parse(localStorage.getItem('mm:user'));

  const { refetchCredits } = useCreditContext();

  useEffect(()=>{
    refetchCredits();
  },[])

  // const [dashCard, setDashCard] = useState([
  //   {
  //     id: 1,
  //     cardName: 'Total Image Generated',
  //     className: 'totalImages',
  //   },
  //   {
  //     id: 2,
  //     cardName: 'Pending Images',
  //     className: 'pendingImages',
  //   },
  //   {
  //     id: 3,
  //     cardName: 'Pending in Manual Editing',
  //     className: 'pendingManualEditing',
  //   },
  //   {
  //     id: 4,
  //     cardName: 'Review Manual Edit Images',
  //     className: 'reviewManualEditing',
  //   },
  // ]);
  const [isActive, setIsActive] = useState('imageGeneration');

  const distributorId = '663b39b3ab4ec46c6ebcf259';

  const token = localStorage.getItem('metamodel_token');

  const onSuccessAllUsersStatsFetch = (data) => {
    setAllUserStats(data?.data?.data);
  };

  const onErrorAllUsersStatsFetch = (err) => {
    message.error(err?.response?.data?.message);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1134);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const { data: allUsersData, refetch } = useGetUserTasksStats(
    'all_users_stats',
    onSuccessAllUsersStatsFetch,
    onErrorAllUsersStatsFetch
  );

  // const { data: taskList } = useGetTask(
  //   'task_list',
  //   onSuccessTaskFetch,
  //   onErrorTaskFetch
  // );

  // const onSuccessTaskFetch = (data) => {
  //     setLoading(false);
  //     setTaskData(data?.data?.data);
  // };

  // const onErrorTaskFetch = (err) => {
  //   message.error(err?.response?.data?.message);
  // };

  const onSuccessListFetch = (data) => {
    if (listPageNum === 1) {
      setLoading(false);
      setListData(data?.data?.data);
    } else {
      setListData((prev) => [...prev, ...data?.data?.data]);
    }
    setlistTotalCount(data?.data?.totalCount);
  };

  const onErrorListFetch = (err) => {
    message.error(err?.response?.data?.message);
  };

  const { data: list } = useGetListAll(
    'list_data',
    listPageNum,
    listPageSize,
    'modelClipper',
    onSuccessListFetch,
    onErrorListFetch
  );

  const onSuccessManualEditingFetch = (data) => {
    if (manualPageNum === 1) {
      setLoading(false);
      setManualData(data?.data?.data);
    } else {
      setManualData((prev) => [...prev, ...data?.data?.data]);
    }
    setManualTotalCount(data?.data?.totalCount);
  };

  const onErrorManualEditingFetch = (err) => {
    message.error(err?.response?.data?.message);
  };



  function getUserFirstName(username) {
    if (username.includes('@')) {
      const emailNamePart = username.split('@')[0];
      let nameParts = emailNamePart.split(/[._-]/);
      nameParts = nameParts[0];
      return nameParts?.charAt(0)?.toUpperCase() + nameParts.slice(1);
    } else {
      let nameParts = username.trim().split(' ');
      nameParts = nameParts[0];
      nameParts = nameParts?.charAt(0)?.toUpperCase() + nameParts.slice(1);
      return nameParts;
    }
  }

  const formatDashboardDate = (isoString) => {
    const date = new Date(isoString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${day}/${month}/${year}`;
  };

  const downloadImages = async (requestId) => {
    const urlDownload =
      isActive === 'imageGeneration'
        ? `https://api-phoenix.metamodels.ai/api/v1/task/zipBodySwapTask?requestId=${requestId}`
        : `https://api-phoenix.metamodels.ai/api/v1/task/zipManualEditingTask?requestId=${requestId}`;

    const response = await fetch(urlDownload, {
      headers: {
        authorization: `Bearer ${token}`,
        distributorId,
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const jsonResponse = await response.json();
    const zipFileUrl = jsonResponse.data.url; // Assuming the URL is provided here

    if (!zipFileUrl) {
      throw new Error('No URL found in response');
    }

    // Second request to actually download the ZIP file
    const zipResponse = await fetch(zipFileUrl);

    if (!zipResponse.ok) {
      throw new Error('Failed to download ZIP file');
    }

    const blob = await zipResponse.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'file.zip'; // Customize the file name
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const { mutate, isLoading, error } = useMutation(downloadImages);

  const handleDownload = (url) => {
    if (!url) {
      message.error("No URL provided for download.");
      return;
    }
    const link = document.createElement('a');
    link.href = url;
    link.download = 'downloaded-file.zip';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  
  const dataSource = listData;

  const columns = [
    {
      title: 'SL No',
      dataIndex: 'key',
      key: 'serialNumber',
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: (
        <div className="date_section">
          Date{' '}
          <img
            src={calendarIcon} // Replace with your desired icon image
            alt="icon" // Adds space between the icon and the text
          />
        </div>
      ),
      dataIndex: `createdAt`,
      key: 'createdAt',
      render: (text, record) => formatDashboardDate(record.createdAt),
    },
    {
      title: 'Batch No.',
      dataIndex: 'requestCode',
      key: 'requestCode',
    },
    {
      title: 'No. of Images',
      dataIndex: 'tasks',
      key: 'tasks',
      render: (text, record) => record?.tasks.length,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => (
        <Tooltip title={record?.statusString} placement="rightTop">
          <div
            className={`status ${record?.statusString === 'Completed' ? 'success' : 'pending'
              } `}
          ></div>
        </Tooltip>
      ),
    },
    {
      title: 'Credit Use',
      dataIndex: 'totalCostToUser',
      key: 'totalCostToUser',
    },
    {
      title: 'Download',
      key: 'download',
      render: (text, record) => (
        
        record?.statusString === 'Completed' && <img
          src={downloadIcon}
          alt=""
          onClick={() => handleDownload(record?.deliveries?.zip?.zipPathBuckets?.[0]?.zipPath?.url)}
          className={`download_icon ${record.totalCostToUser === 0 ? 'disabled' : ''
            }`}
        />
        
      ),
      
    },
    // {
    //   title: '', 
    //   key: 'viewImages',
    //   render: (text, record) => (
    //     <button
    //       onClick={() => {
    //         setTaskData(record);
    //         handleImages(record?.id);
    //       }
    //       }
    //       className="view_images"
    //     >
    //       View Images
    //     </button>
    //   ),
    // },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
    middleRowRef.current.scrollIntoView();
  };

  // Paginated data slice
  const paginatedData = dataSource.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  useEffect(() => { }, [allUserStats]);

  const getStats = () => {
    const bodySwapData = allUserStats?.find((item) => item._id === 'modelClipper');
    // const manualEditingData = allUserStats?.find(
    //   (item) => item._id === 'manualEditing'
    // );
    return (
      <div className="dashboard_info_wrapper">
        {isMobile && (
          <div className="create_new_image">
            <Button
              text="Create Request"
              width={'100%'}
              height={'75px'}
              handleClick={() => navigate('/')}
            />
          </div>
        )}
        <div className="dashboard_info_card totalImages">
          <h3>Total Image Generated</h3>
          <span>{bodySwapData?.completed || 0}</span>
        </div>
        <div className="dashboard_info_card pendingImages">
          <h3>Pending Images</h3>
          <span>{bodySwapData?.pending || 0}</span>
        </div>
        {/* <div className="dashboard_info_card pendingManualEditing">
          <h3>Pending in Manual Editing</h3>
          <span>{manualEditingData?.pending || 0}</span>
        </div> */}
        {/* <div className='dashboard_info_card reviewManualEditing'>
          <h3>Review Manual Editing Images</h3>
          <span>{0}</span>
        </div> */}
      </div>
    );
  };

  return (
    <div className="dashboard_main_wrapper">
      <div className="dashboard_content_section">
        <div className="user_profile_wrapper">
          <h2>Hi, {getUserFirstName(userInfo?.userName)}!</h2>
        </div>
        {getStats()}
        {/* <div className="filter_wrapper">
          <button
            className={`image_generation ${
              isActive === 'imageGeneration' ? 'active' : ''
            }`}
            onClick={() => {
              handleTabSwitch('imageGeneration');
            }}
          >
            Image Generation
          </button>
          <button
            className={`manual_editing ${
              isActive === 'manualEditing' ? 'active' : ''
            }`}
            onClick={() => handleTabSwitch('manualEditing')}
          >
            Manual Editing
          </button>
        </div> */}
        {!isMobile && (
          <div className="table_wrapper" ref={middleRowRef}>
            {loading ? (
              <div className="spinner">
                <Spin
                  indicator={
                    <LoadingOutlined
                      style={{
                        fontSize: 40,
                        color: '#ff6666',
                        marginLeft: '20px',
                      }}
                      spin
                    />
                  }
                />
              </div>
            ) : (
              <Table
                dataSource={paginatedData}
                columns={columns}
                pagination={false}
              />
            )}
          </div>
        )}

        {isMobile && (
          <div className="mobile_table">
            <div className="table_header">
              <div className="table_head">SL No</div>
              <div className="table_head date_section">
                Date <img src={calendarIcon} alt="icon" />
              </div>
              <div className="table_head">No of Images</div>
              <div className="table_head">Status</div>
              <div className="table_head">Credit Use</div>
            </div>
            <div
              className="image_container_div"
              id="image_container_div"
              ref={middleRowRef}
            >
              {paginatedData.map((list, index) => (
             
             
                <div className="table_row" key={list?._id}>
                  <div className="table_data">
                    {(currentPage - 1) * pageSize + index + 1}
                  </div>
                  <div className="table_data">
                    {formatDashboardDate(list?.createdAt)}
                  </div>
                  <div className="table_data">{list?.tasks?.length}</div>
                  <div
                    className={`status ${list?.statusString === 'Completed' ? 'success' : 'pending'
                      } `}
                  ></div>
                  <div className="table_data">{list?.totalCostToUser}</div>
                 <div className="table_data two_column">
                    {/* <button
                      onClick={() =>
                        navigate('/my-images?tab=generated-images')
                      }
                      className="view_images"
                    >
                      View Images
                    </button> */}
                    {list?.statusString === 'Completed' && <img
                      src={downloadIcon}
                      alt=""
                      onClick={() => handleDownload(list?.deliveries?.zip?.zipPathBuckets?.[0]?.zipPath?.url)}
                      className={`download_icon ${list?.totalCostToUser === 0 ? 'disabled' : ''
                        }`}
                    />}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        <Pagination
          current={currentPage}
          total={dataSource.length}
          pageSize={pageSize}
          onChange={handlePageChange}
          showSizeChanger={false} // Hide page size changer
          style={{ marginTop: '16px', textAlign: 'right' }} // Add some spacing and centering
        />


      </div>
    </div>
  );
};
export default Dashboard;
